<template>
	<div class="chinaEuropeTrain">

		<Header :typeHeader="'defaultHeader'">
			<!-- banner -->
			<img slot="headerImage" :src="imgList.bannerImg" alt="">
			<!-- 标题 -->
			<div slot="headerTitle">{{$store.state.navShow == true ?'中俄运输':'Sino-Russian transportation'}}</div>
			<div style="font-size: 1.125rem; color: #FFFFFF; font-weight: 100; margin-top: 0.6rem;" slot="headerTitle">
				{{$store.state.navShow == true ? 'MG集团可提供中俄两国间的国际物流服务' :'MG Group can provide international logistics between China and Russia'}}</div>
		</Header>

		<div class="TopTitle" data-aos="fade-up">
			<div class="">
				<!-- {{this.$route.name}} -->
			{{$store.state.navShow == true ? $route.name : $route.meta.EnName}}
			</div>
		</div>
		<div class="ContentText" data-aos="fade-down">
			<p>{{$store.state.navShow == true ? 'MG集团在俄罗斯本土拥有强大的铁路运输资源优势，运输网络遍布俄罗斯，在海运方面有十余年运营经验；在俄罗斯汽车陆运市场占有重要地位，拥有300余辆皮卡厢式货车，可提供“站到站”“门到门”服务；空运方面提供“石家庄—莫斯科”货运包机专线；专业化的服务团队熟悉本国政策及操作流程，可提供中俄两国国际物流的一站式服务。':'MG Group has a strong advantage in railway transportation resources in Russia, and its transportation network covers all over Russia. It has more than ten years of operation experience in shipping. It occupies an important position in the Russian automobile land transport market, with more than 300 pickup vans, which can provide "station to station" and "door to door" services.In Air transport, it owns "Shijiazhuang - Moscow" cargo charter line; In service, it has professional service team who are familiar with the national policy and operation process, can provide China and Russia international logistics one-stop service.'}}</p>
		</div>

		<div class="Contentbusiness">
			<img class="backgroundImg" :src="imgList.backgroundImg">
			<div class="businessCon">
				<p class="tableTitleTitle">{{$store.state.navShow == true ?'核心业务':'Core business'}}</p>
				<div class="businessConList" v-for="(item,index) in $store.state.navShow == true ? businessImgList :businessImgListE" :key="index" :data-id="item.id" :data-aos="item.aos">
					<img class="businessConListImg" :src="item.img">
					<div class="businessConIntroduce">
						<div class="businessConTitle">{{ item.title }}</div>
						<div class="businessConText">{{ item.content }}</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 		<p class="tableTitleTitle">海铁联运精品线路</p>
		<p class="tableTitlePText">拥有专业化管理团队和精细化运营模式，打造了海铁联运精品线路 </p> -->

		<!-- 		<div class="ContenImg" data-aos="fade-up">
			<img :src="imgList.maps">
		</div>

		<div class="ContenImg_2" data-aos="fade-up">
			<img class="ContenImg_2_1" :src="imgList.textimg">
			<img class="ContenImg_2_2" :src="imgList.textimg2">
		</div> -->

		<div class="buttonImgSRR">
			<img :src="imgList.bottonImg">
		</div>
	</div>
</template>

<script>
	import Header from "@/components/header.vue";
	export default {
		components: {
			Header,
		},
		data() {
			return {

				imgList: {
					bannerImg: require('@/assets/chinaAndRussia/CR_sinoRussianRailwaybanner.jpg'),
					backgroundImg: require('@/assets/chinaAndRussia/backgroundImg.png'),
					// textimg: require('@/assets/chinaAndRussia/text.png'),
					bottonImg: require('@/assets/chinaAndRussia/bottonImg.png'),
				},
				businessImgList: [{
						img: require('@/assets/chinaAndRussia/list_1.png'),
						id: 1,
						title: '铁路运输',
						content: '中欧班列，石家庄至莫斯科铁路路线',
						aos:''
					},
					// {
					// 	img: require('@/assets/chinaAndRussia/list2_1.png'),
					// 	id: 8,
					// 	title: '国际贸易',
					// 	content: '能源,沥青,粮食,肉类,木材等领域',
					// 	aos:''
					// },
					// {
					// 	img: require('@/assets/chinaAndRussia/list2_2.png'),
					// 	id: 9,
					// 	title: '中欧班列境外服务商',
					// 	content: '国际运输网络及口岸代理点,集装箱调运口岸换装,车板资源',
					// 	aos:''
					// },
					{
						img: require('@/assets/chinaAndRussia/list_2.png'),
						id: 2,
						title: '空运服务',
						content: '每周一趟石家庄—莫斯科货运包机',
						aos:''
					},
					{
						img: require('@/assets/chinaAndRussia/list_3.png'),
						id: 3,
						title: '汽车运输',
						content: '在俄专业货运车队已拥有260余辆皮卡厢式货车400余 辆配送车，覆盖俄罗斯莫斯科全境',
						aos:''
					},
					{
						img: require('@/assets/chinaAndRussia/list_4.png'),
						id: 4,
						title: '海运服务',
						content: '在圣彼得堡、海参崴、新罗西斯克、纳霍德卡港等俄罗 斯重要港口都设有办事处',
						aos:'fade-up-down'
					},
					{
						img: require('@/assets/chinaAndRussia/list_5.png'),
						id: 5,
						title: '海外仓',
						content: '100000㎡莫斯科海外仓，先进的仓储管理系统',
						aos:'fade-up-down'
					},
					{
						img: require('@/assets/chinaAndRussia/list_6.png'),
						id: 6,
						title: '中俄清关',
						content: '国家级清关行，在俄罗斯关键港口设置海关护送团队 提供高效的清关服务',
						aos:'fade-up-down'
					},
					{
						img: require('@/assets/chinaAndRussia/list_7.png'),
						id: 7,
						title: '跨境电商',
						content: '国内与欧亚电商平台对接＋双向物流仓储＋境外本土 电商营销团队',
						aos:'fade-up-down'
					},
				],

				businessImgListE: [{
						img: require('@/assets/chinaAndRussia/list_1.png'),
						id: 1,
						title: 'Railway transportation',
						content: 'Normalized Issuance of China-Europe railway express',
						aos:''
					},
					// {
					// 	img: require('@/assets/chinaAndRussia/list2_1.png'),
					// 	id: 8,
					// 	title: '国际贸易',
					// 	content: '能源,沥青,粮食,肉类,木材等领域',
					// 	aos:''
					// },
					// {
					// 	img: require('@/assets/chinaAndRussia/list2_2.png'),
					// 	id: 9,
					// 	title: '中欧班列境外服务商',
					// 	content: '国际运输网络及口岸代理点,集装箱调运口岸换装,车板资源',
					// 	aos:''
					// },
					{
						img: require('@/assets/chinaAndRussia/list_2.png'),
						id: 2,
						title: 'Air freight service',
						content: 'A weekly charter flight between Shijiazhuang and Moscowa',
						aos:''
					},
					{
						img: require('@/assets/chinaAndRussia/list_3.png'),
						id: 3,
						title: 'Motor Transport',
						content: 'Professional freight fleets in Russia have owned pickup wansMore than 800 delivery vehicles, covering the whole territoryaf Moscow, Russia',
						aos:''
					},
					{
						img: require('@/assets/chinaAndRussia/list_4.png'),
						id: 4,
						title: 'Maritime transport services',
						content: 'ln St. Petersburg. sea cucumber, novarossisk, nahodka port, etc All major Russlan ports have offilces',
						aos:'fade-up-down'
					},
					{
						img: require('@/assets/chinaAndRussia/list_5.png'),
						id: 5,
						title: 'Overseas warehouse',
						content: 'Covering an area of 100000 square melers, Moscow overseas warehouse, advanced warehouse management system',
						aos:'fade-up-down'
					},
					{
						img: require('@/assets/chinaAndRussia/list_6.png'),
						id: 6,
						title: 'Sino-Russian customs clearance',
						content: 'State level customs clearance, and set up customs in keyRussian ports Escort team, to provlde efficlent customs clearance services',
						aos:'fade-up-down'
					},
					{
						img: require('@/assets/chinaAndRussia/list_7.png'),
						id: 7,
						title: 'Cross-border E- commerce',
						content: 'Domestic and Eurasian e-commerce platform docking+ two-way Loglistics Warehousing + overseas and local e-commerce management and sales team',
						aos:'fade-up-down'
					},
				]
			}
		},
		methods: {


		}
	}
</script>

<style lang="less">
	.TopTitle {
		width: 92%;
		height: 4.95rem;
		position: relative;
		margin: 0 4%;
		top: -3.2rem;
		border-bottom: 1px solid rgba(204, 204, 204, .5);

		&>div {
			position: absolute;
			top: 1.25rem;
			font-size: 1rem;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #FFFFFF;
			padding: 1.2rem 3.375rem 1.2rem 0.75rem;
			background: #2e67b1 linear-gradient(
270deg,rgba(3,0,0,.15),hsla(0,0%,100%,.15));
		}
	}

	.ContentText {
		width: 92%;
		margin: 0 4%;
		// background-color: #000066;
		margin-top: -1.575rem;
		text-align: left;

		&>p {
			font-size: 0.875rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #666666;
			text-indent: 2em;
			margin-bottom: 1.25rem;
			text-align: justify;
		}
	}







	.tableTitleTitle {
		// margin: 1.875rem 0 0.625rem 0;
		font-size: 1rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #2E67B1;
		text-align: left;
		margin-bottom: 1.1875rem;
	}

	.tableTitlePText {
		font-size: 0.625rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}

	.Contentbusiness {
		width: 100%;
		position: relative;
		height: 43.0625rem;
		// height: auto;

		.backgroundImg {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 21.5625rem;
			z-index: -1;
		}

		.businessCon {
			// position: absolute;
			top: 20px;
			width: 92%;
			margin: 0 4%;

			.businessConList {
				background: #FFFFFF;
				box-shadow: 0px 0px 20px 0px rgba(41, 92, 169, 0.1);
				display: flex;
				padding: 0.625rem 0.6875rem;
				align-items: center;
				justify-content: flex-start;
				margin-bottom: 0.3125rem;

				.businessConListImg {
					min-width: 3.440625rem;;
					min-height: 3.440625rem;;
					width: 3.440625rem;
					height: 3.440625rem;
				}

				.businessConIntroduce {
					text-align: left;
					margin-left: 1.1875rem;

					.businessConTitle {
						margin-bottom: 0.53125rem;
						font-size: 0.9125rem;
						font-family: Microsoft YaHei;
						font-weight: bold;
						color: #2E67B1;
					}

					.businessConText {
						font-size: 0.725rem;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #666666;
						line-height: 1rem;
					}

				}

			}
		}
	}

	// .ContenImg {
	// 	width: 100%;
	// 	height: 14.3125rem;
	// 	margin-top: 2.0875rem;
	// 	// margin-bottom: 1.0875rem;

	// 	&>img {
	// 		width: 100%;
	// 		height: 100%;
	// 	}
	// }

	// .ContenImg_2 {
	// 	width: 100%;
	// 	height: 16.3125rem;
	// 	margin-bottom: 1.0875rem;
	// 	position: relative;

	// 	&>img {
	// 		position: absolute;
	// 		left: 0;
	// 	}

	// 	.ContenImg_2_1 {
	// 		width: 100%;
	// 		height: 100%;
	// 		top: 0;
	// 	}

	// 	.ContenImg_2_2 {
	// 		height: 65%;
	// 		bottom: -10%;
	// 	}
	// }


	.buttonImgSRR {
		width: 100%;
		height: 4.9375rem;
		// height: 3.125rem;
		// margin-top: 0.78125rem;
	}
</style>
